import moment from 'moment';
import humanFormat from 'human-format';

const sinceYears = (d, extra = false) => {
  const y = Math.floor(Math.abs(moment().diff(d, 'month')) / 12);
  const years = !y ? '(1st year)' : `(${y}+ year${y > 1 ? 's' : ''})`;
  return `${extra ? moment(d).format('MMM YYYY') : ''} ${years}`;
};

const yearsAndMonthsAgo = d => {
  const y = moment().diff(d, 'years');
  const m = moment().diff(moment(d).add(y, 'years'), 'months');
  const years = !y ? '' : `${y} year${y > 1 ? 's' : ''}`;
  const months = !m ? '' : `${m} month${m > 1 ? 's' : ''}`;
  return `${years}${(years && months) ? ' and ' : ''}${months}${(years || months) ? ' ago' : ''}`
    || 'Less than a month ago';
};

const formatPercent = d => `${Number(d).toFixed(2)}%`;

const formatCurrency = (v, d) => `$${humanFormat(v, { decimals: d, separator: '' })}`;

const formatValue = (value, percentage) => (
  /* eslint-disable-next-line no-nested-ternary */
  value ? (percentage ? formatPercent(value) : `$${Number(value).toFixed(2)}`) : 'N/A'
);

export {
  sinceYears,
  yearsAndMonthsAgo,
  formatCurrency,
  formatPercent,
  formatValue,
};
